import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import toastMessage from '../../../components/ToastMessage';
import { toaster } from 'rsuite';
import {
	DeveloperDetailsReturnTypes
} from '../../../constants/profile-settings/bussiness-settings-developer-details-form';
import {
	CustomerSupportReturnTypes
} from '../../../constants/profile-settings/bussiness-settings-customer-support-form';

export const setDevelopersDetailsData = async (id: string, params: DeveloperDetailsReturnTypes): Promise<void> => {
	try {
		await axios.put(`${BASE_URL.MERCHANTS}/merchant/${id}/developer-details`, params);
		toaster.push(toastMessage({
			text: 'Developer details were saved!',
			type: 'success'
		}), { placement: 'topEnd' });
	} catch (e) {
		console.log(e);
	}
};

export const setCustomerSupportData = async (id: string, params: CustomerSupportReturnTypes): Promise<void> => {
	try {
		await axios.put(`${BASE_URL.MERCHANTS}/merchant/${id}/customer-support`, params);
		toaster.push(toastMessage({
			text: 'Customer support was saved!',
			type: 'success'
		}), { placement: 'topEnd' });
	} catch (e) {
		console.log(e);
	}
};
